// src/features/aws-user/auth.ts
import { Auth } from 'aws-amplify';
import {AppDispatch, resetAppState} from '@app/store';
import { riotApi } from './api';

export const resetUserState = async (dispatch: AppDispatch) => {
  try {
    // Sign out from Cognito first so prepareHeaders fails cleanly
    // before we clear the API cache (which would trigger refetches)
    await Auth.signOut({ global: true });
  } catch (error) {
    console.error('Cognito signout error (continuing cleanup):', error);
    // Continue cleanup even if signout fails
  }

  try {
    localStorage.clear();
    dispatch(riotApi.util.resetApiState());
    dispatch(resetAppState());
  } catch (error) {
    console.error('Error during state cleanup:', error);
    throw error;
  }
};
